import { createFileRoute } from "@tanstack/react-router";
import { LinkListContent } from "@/features/study-group-link-list/components/LinkListContent";

export const Route = createFileRoute("/study-group/$study-group-id/link-list")({
  component: LinkListContent,
});
